// @flow
import { connect } from 'react-redux';

import { loadCompletions, localize } from 'actions/geocoder';

import LocationSearchField from './LocationSearchField';

const mapStateToProps = ({ browser, geocoder }) => ({
  browser,
  geocoder,
});
const mapDispatchToProps = { loadCompletions, localize };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationSearchField);



// WEBPACK FOOTER //
// ./components/LocationSearchField/index.js